import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <div>
      <h2>{`GIPHY SDK for React Native`}</h2>
      <h3>{`Requirements`}</h3>
      <ul>
        <li parentName="ul">{`Android:`}
          <ul parentName="li">
            <li parentName="ul">{`Giphy SDK only supports projects that have been upgraded to androidx`}</li>
            <li parentName="ul">{`Requires minSdkVersion 21`}</li>
            <li parentName="ul"><a parentName="li" {...{
                "href": "https://developers.giphy.com/dashboard/?create=true"
              }}>{`A Giphy API key`}</a></li>
          </ul>
        </li>
        <li parentName="ul">{`iOS:`}
          <ul parentName="li">
            <li parentName="ul">{`iOS 10.2 or later`}</li>
            <li parentName="ul">{`Xcode 12 and later`}</li>
            <li parentName="ul"><a parentName="li" {...{
                "href": "https://developers.giphy.com/dashboard/?create=true"
              }}>{`A Giphy API key`}</a></li>
          </ul>
        </li>
      </ul>
      <h3>{`Installation`}</h3>
      <pre><code parentName="pre" {...{
          "className": "language-bash"
        }}>{`yarn add @giphy/react-native-sdk
# or using npm
npm install @giphy/react-native-sdk --save
# Go to your iOS folder and run
pod install
`}</code></pre>
      <p>{`Get started with our React Native docs `}<a parentName="p" {...{
          "href": "https://github.com/Giphy/giphy-react-native-sdk/blob/main/README.md"
        }}>{`here`}</a>{`.`}</p>
      <h3>{`Useful links`}</h3>
      <ul>
        <li parentName="ul">{`View the `}<a parentName="li" {...{
            "href": "https://github.com/Giphy/giphy-react-native-sdk/blob/main/README.md"
          }}>{`docs`}</a>{`.`}</li>
        <li parentName="ul">{`Give the React Native SDK `}<a parentName="li" {...{
            "href": "https://github.com/Giphy/giphy-react-native-sdk/tree/main/example"
          }}>{`example app`}</a>{` a spin to see what it's all about.`}</li>
        <li parentName="ul">{`View `}<a parentName="li" {...{
            "href": "https://github.com/Giphy/giphy-react-native-sdk/releases"
          }}>{`releases`}</a></li>
        <li parentName="ul">{`Open `}<a parentName="li" {...{
            "href": "https://github.com/Giphy/giphy-react-native-sdk/issues"
          }}>{`issues or feature requests`}</a></li>
      </ul>
    </div>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      